import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const LOGO = "https://customer-assets.emergentagent.com/job_c505dbd1-2d03-4d09-ad34-8400394a0109/artifacts/ew4jpsol_59FD7A52-BDD4-4C02-94C7-FEB6D8870598.png";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", r.data.token);
      localStorage.setItem("admin_email", r.data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-stretch bg-zinc-950">
      <div className="hidden lg:flex flex-col justify-between p-12 w-1/2 bg-zinc-950 text-white border-r border-zinc-800">
        <Link to="/" data-testid="admin-back-home" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-[#16A34A] transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
        <div className="flex flex-col items-start gap-8">
          <img src={LOGO} alt="Nomad Caravan Repairs" className="w-44 h-44 rounded-full shadow-2xl" />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#16A34A] mb-4">Workshop Control</div>
            <h2 className="font-display text-5xl font-black tracking-tighter leading-[0.95]">Every lead.<br/>Every request.<br/><span className="text-zinc-500">One place.</span></h2>
          </div>
        </div>
        <div className="font-mono text-xs text-zinc-500">© Nomad Caravan Repairs · Bowen / Whitsundays</div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center p-6 bg-white relative">
        <Link
          to="/"
          data-testid="admin-back-home-mobile"
          className="absolute top-6 left-6 inline-flex items-center gap-2 text-sm font-semibold text-zinc-700 hover:text-[#16A34A] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>

        <form onSubmit={submit} className="w-full max-w-sm">
          <img src={LOGO} alt="Nomad Caravan Repairs" className="lg:hidden w-24 h-24 rounded-full mx-auto mb-6 shadow-lg" />
          <div className="hidden lg:flex w-12 h-12 bg-zinc-950 text-white items-center justify-center mb-8"><Lock className="w-5 h-5" /></div>
          <h1 className="font-display text-3xl font-black tracking-tight text-center lg:text-left">Admin Sign in</h1>
          <p className="mt-2 text-sm text-zinc-500 text-center lg:text-left">Restricted area — Nomad workshop staff only.</p>
          <div className="mt-8 space-y-4">
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="mt-2 w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-[#16A34A]"
              />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="mt-2 w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-[#16A34A]"
              />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full bg-[#16A34A] text-white py-3 font-semibold hover:bg-[#15803D] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
